module.exports = __webpack_public_path__ + "img/background.b37d0f28.jpg";